import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";

const SECCIONES = [
  { key: "header", label: "Encabezado (barra de arriba, \"Sistema de Citas\")" },
  { key: "footer", label: "Pie de página" },
  { key: "sidebar", label: "Menú lateral del Panel de Administración" },
];

const GestionarColoresSitio = () => {
  const [colorBase, setColorBase] = useState("#1e40af");
  const [overrides, setOverrides] = useState({ header: null, footer: null, sidebar: null });
  const [headerDifuminado, setHeaderDifuminado] = useState(false);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/colores-sitio`);
        setColorBase(res.data.color_base || "#1e40af");
        setOverrides({
          header: res.data.color_header || null,
          footer: res.data.color_footer || null,
          sidebar: res.data.color_sidebar || null,
        });
        setHeaderDifuminado(!!res.data.header_difuminado);
      } catch (err) {
        console.error("Error al cargar colores del sitio:", err);
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  const togglePersonalizar = (key, activar) => {
    setOverrides((prev) => ({
      ...prev,
      [key]: activar ? colorBase : null,
    }));
  };

  const cambiarOverride = (key, valor) => {
    setOverrides((prev) => ({ ...prev, [key]: valor }));
  };

  const guardar = async () => {
    try {
      setGuardando(true);
      await axios.post(`${API_URL}/api/colores-sitio`, {
        color_base: colorBase,
        color_header: overrides.header,
        color_footer: overrides.footer,
        color_sidebar: overrides.sidebar,
        header_difuminado: headerDifuminado,
      });
      alert("🎨 Colores del sitio actualizados. Los cambios se verán al recargar la página.");
    } catch (err) {
      console.error("Error al guardar colores del sitio:", err);
      alert("❌ No se pudo guardar. Revisa la consola.");
    } finally {
      setGuardando(false);
    }
  };

  if (loading) return <p>Cargando...</p>;

  return (
    <div style={{ maxWidth: 640, margin: "0 auto" }}>
      <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 6, color: "#1e3a8a" }}>
        🎨 Colores del Sitio
      </h2>
      <p style={{ color: "#64748b", fontSize: 14, marginBottom: 24 }}>
        Define un color base que se aplica al encabezado, pie de página y menú
        lateral. Si quieres que alguna de esas partes use un color distinto,
        actívalo abajo y personalízalo aparte.
      </p>

      {/* COLOR BASE */}
      <div
        style={{
          background: "#f0f4ff",
          borderRadius: 14,
          padding: "20px",
          marginBottom: 20,
          display: "flex",
          alignItems: "center",
          gap: 16,
        }}
      >
        <input
          type="color"
          value={colorBase}
          onChange={(e) => setColorBase(e.target.value)}
          style={{ width: 60, height: 60, border: "none", cursor: "pointer", borderRadius: 8 }}
        />
        <div style={{ flex: 1 }}>
          <strong style={{ display: "block", fontSize: 15 }}>Color base</strong>
          <span style={{ fontSize: 13, color: "#64748b" }}>
            Se usa en todas las secciones que no tengan un color personalizado.
          </span>
          <input
            type="text"
            value={colorBase}
            onChange={(e) => setColorBase(e.target.value)}
            style={{
              display: "block",
              marginTop: 8,
              fontFamily: "monospace",
              fontSize: 13,
              padding: "4px 8px",
              borderRadius: 6,
              border: "1px solid #cbd5e1",
              width: 100,
            }}
          />
        </div>
      </div>

      {/* SECCIONES PERSONALIZABLES */}
      {SECCIONES.map(({ key, label }) => {
        const personalizado = overrides[key] !== null;
        return (
          <div
            key={key}
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: 14,
              padding: "16px 20px",
              marginBottom: 14,
            }}
          >
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={personalizado}
                onChange={(e) => togglePersonalizar(key, e.target.checked)}
              />
              <span style={{ fontWeight: 600, fontSize: 14 }}>{label}</span>
            </label>

            {personalizado ? (
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12 }}>
                <input
                  type="color"
                  value={overrides[key]}
                  onChange={(e) => cambiarOverride(key, e.target.value)}
                  style={{ width: 44, height: 44, border: "none", cursor: "pointer", borderRadius: 6 }}
                />
                <input
                  type="text"
                  value={overrides[key]}
                  onChange={(e) => cambiarOverride(key, e.target.value)}
                  style={{
                    fontFamily: "monospace",
                    fontSize: 13,
                    padding: "4px 8px",
                    borderRadius: 6,
                    border: "1px solid #cbd5e1",
                    width: 100,
                  }}
                />
                <span style={{ fontSize: 13, color: "#64748b" }}>Color personalizado para esta sección</span>
              </div>
            ) : (
              <p style={{ fontSize: 13, color: "#94a3b8", marginTop: 8, marginLeft: 26 }}>
                Usando el color base ({colorBase})
              </p>
            )}

            {key === "header" && (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: 12,
                  marginLeft: 26,
                  fontSize: 13,
                  color: "#475569",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={headerDifuminado}
                  onChange={(e) => setHeaderDifuminado(e.target.checked)}
                />
                Difuminado (se degrada hacia blanco, para que se vea continuo con el fondo de la página)
              </label>
            )}
          </div>
        );
      })}

      <button
        onClick={guardar}
        disabled={guardando}
        style={{
          marginTop: 10,
          padding: "12px 28px",
          backgroundColor: "#2563eb",
          color: "white",
          border: "none",
          borderRadius: 10,
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        {guardando ? "Guardando..." : "Guardar cambios"}
      </button>
    </div>
  );
};

export default GestionarColoresSitio;
